<template>
	<div>
		<hyper-backup  @selectVersion="onSelectVersion" @showDiff="onShowDiff" @newFilter="onNewFilter" ref="hBack"></hyper-backup>
	</div>
</template>

<script>
import '@hyper-cloud/hyper-backup-wc/hyper-backup-wc.js';
import ErrorUtil from '../../util/error.util';
import BackupService from '../../services/backup';

export default {
	name: 'VersionsDialog',
	methods: {
		data: function () {
			return {
				collectionName: "" ,
				current: null,
				chosen: null
			}
		},
		load(versionsFilter) {
			return Promise.all([
				BackupService.instance().getVersions(versionsFilter).then(versions => (this.versions = versions))
					.catch(e => this.toastError('Versions', 'Failed to fetch versions', e))
			]);
		},
		show(versionsFilter) {
			this.collectionName = versionsFilter.collectionName;
			this.load(versionsFilter).then(data => {
					this.$refs.hBack.openDialogueExt(data[0], versionsFilter, true);
				});
		},
		onShowDiff(event) {
			let versionObj = event.detail;
			let filter = {
				collectionName: this.collectionName,
				backupId: versionObj.backupId,
				objectName: versionObj.objectName
			};
			BackupService.instance().getCurrentAndChosenVersions(filter).then((data) => {
				// this.current = data[0].data;
				// this.chosen = data[1].data;
                this.$emit('selectversions', {chosen: data[1].data});
				// this.$refs.hBack.loadDiffWc(data[0].data, data[1].data);
			});
		},
		onNewFilter(event) {
			let newFilter = event.detail;
			this.backupService.getVersions(newFilter)
			.then((data) => {
				this.$refs.hBack.changeVersions(data);
			});
		},
		onSelectVersion() {
			this.$emit('selectversions', {chosen: this.chosen, current: this.current});
		},
		toastError(title, message, error) {
			this.toast(
				'danger',
				title,
				`${message}. ${ErrorUtil.getErrorMessage(error)}.`
			);
		},
		toast(variant, title, text) {
			this.$bvToast.toast(text, {
				title: title,
				autoHideDelay: 5000,
				variant: variant,
				append: true,
				toaster: 'b-toaster-bottom-right'
			});
		}
	}
};
</script>

<style scoped>
</style>
